import { css, styled } from '@mui/material';

export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledFormLegend = styled('legend')(
  ({ theme }) => css`
    padding: 0;
    margin-bottom: ${theme.spacing('SMALL')};
  `
);

export const StyledInputGroup = styled('div')(
  ({ theme }) => css`
    display: flex;
    column-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledBigInputContainer = styled('div')`
  flex: 4 1 0;
`;

export const StyledSmallInputContainer = styled('div')`
  flex: 1 1 0;
`;
